import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/websocket/:method' }

type Params = { method: string }
type Body = { [key: string]: any } // We're not doing validation here the websocket router will do it for us
type Query = never
type Output = { [key: string]: any } // We're not doing validation here the websocket router will do it for us

export type ProxyEndpoint = Endpoint<Params, Body, Query, Output>

export const proxyRequest = (request: Request, args: RequestArgs<ProxyEndpoint>) => request<ProxyEndpoint>(route, args)
